import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { CoreBox } from '@youscience/core';

import ActionButton from '@components/ActionButton';

import {
  sxStyles,
  StyledReducedSchoolCard,
  StyledSchoolDetailsContainer,
  StyledActionsContainer,
  StyledMoreLink,
} from './ReducedSchoolCard.styles';

export const InfographicItemSkeleton = () => {
  return (
    <Stack spacing={1}>
      <Skeleton variant="rounded" width={65} height={10} />

      <Stack spacing={1} direction="row">
        <Skeleton variant="rounded" width={20} height={20} />

        <Skeleton variant="rounded" width={40} height={20} />
      </Stack>
    </Stack>
  );
};

interface ReducedCardSkeleton {
  isHideActions?: boolean;
  isFluid?: boolean;
}

export const ReducedCardSkeleton = (props: ReducedCardSkeleton) => {
  const { isHideActions, isFluid } = props;

  return (
    <StyledReducedSchoolCard isFluid={isFluid}>
      <CoreBox sx={sxStyles.infographicContainer}>
        <InfographicItemSkeleton />

        <InfographicItemSkeleton />

        <InfographicItemSkeleton />
      </CoreBox>

      <Skeleton variant="rectangular" width="100%" height={183} />

      <StyledSchoolDetailsContainer spacing={2}>
        <Skeleton variant="rounded" height={22} />

        <Skeleton variant="rounded" height={22} />

        <Stack spacing={1} direction="row">
          <Skeleton variant="rounded" width={20} height={20} />

          <Skeleton variant="rounded" width="91%" height={20} />
        </Stack>
      </StyledSchoolDetailsContainer>

      {!isHideActions && (
        <StyledActionsContainer>
          <ActionButton sx={sxStyles.favorite} variant="text" type="button">
            <Skeleton variant="rounded" width={21} height={20} />
          </ActionButton>

          <StyledMoreLink to="">
            <Skeleton variant="rounded" width={70} height={20} />
          </StyledMoreLink>
        </StyledActionsContainer>
      )}
    </StyledReducedSchoolCard>
  );
};
